import Skeleton from 'antd/lib/skeleton'

export const AvatarSkeleton = ({
  size = 'small',
  shape = 'square',
  height,
  width,
  backgroundColor = '',
  className = ''
}) => {
  return (
    <Skeleton.Avatar
      size={size}
      shape={shape}
      style={{ height: height, width: width, backgroundColor: backgroundColor, borderRadius: 0 }}
      active={true}
      className={className}
    />
  )
}

export const InputSkeleton = ({
  size = 'small',
  width = '100%',
  height,
  backgroundColor = '',
  className = '',
  uniqKey = ''
}) => {
  return (
    <Skeleton.Input
      {...{ key: uniqKey }}
      size={size}
      style={{
        width: width,
        height: height,
        backgroundColor: backgroundColor,
        display: 'flex',
        borderRadius: 0
      }}
      active={true}
      className={className}
    />
  )
}

export const ParagraphSkeleton = ({ rows }) => {
  return <Skeleton paragraph={{ rows: rows }} active={true} />
}
